// extracted by mini-css-extract-plugin
export default {"list":"R48l1J","item":"fGQaI3","first":"tExZ1y","link":"afhuBi","alignLeft":"Skzhu9","alignCenter":"bcGSQK","alignRight":"pL1HZm","text":"SwUB5x","message":"ZlkxRP"};